import { apiClient } from './api'

export interface ApprovalRouteVersion {
  approvalRouteVersionId: string
  routeName: string
  routes: string
  status: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED'
  description: string | null
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
  version: number
}

export interface ApprovalRouteDetail extends ApprovalRouteVersion {
  referencedCount: number
  referencedStates: string[]
}

export interface CreateApprovalRouteRequest {
  routeName: string
  routes: string
  description?: string
}

export interface UpdateApprovalRouteRequest {
  routeName: string
  routes: string
  description?: string
}

export interface LintRequest {
  routes: string
}

export interface LintResponse {
  pass: boolean
  warnings: string[]
  errors: string[]
}

export class ApprovalRouteVersionService {
  static async getAll(params?: {
    q?: string
    status?: string
  }): Promise<ApprovalRouteVersion[]> {
    const queryParams = new URLSearchParams()
    if (params?.q) queryParams.append('q', params.q)
    if (params?.status) queryParams.append('status', params.status)

    const queryString = queryParams.toString()
    const url = queryString ? `/api/approval-route-versions?${queryString}` : '/api/approval-route-versions'
    return apiClient.get<ApprovalRouteVersion[]>(url)
  }

  static async getById(id: string): Promise<ApprovalRouteDetail> {
    return apiClient.get<ApprovalRouteDetail>(`/api/approval-route-versions/${id}`)
  }

  static async getPublished(): Promise<ApprovalRouteVersion[]> {
    return apiClient.get<ApprovalRouteVersion[]>('/api/approval-route-versions/published')
  }

  static async create(data: CreateApprovalRouteRequest): Promise<ApprovalRouteVersion> {
    return apiClient.post<ApprovalRouteVersion>('/api/approval-route-versions', data)
  }

  static async update(id: string, data: UpdateApprovalRouteRequest): Promise<ApprovalRouteVersion> {
    return apiClient.put<ApprovalRouteVersion>(`/api/approval-route-versions/${id}`, data)
  }

  static async lint(idOrRequest: string | LintRequest): Promise<LintResponse> {
    if (typeof idOrRequest === 'string') {
      // ID指定版
      return apiClient.post<LintResponse>(`/api/approval-route-versions/${idOrRequest}/lint`, {})
    } else {
      // データ直接指定版
      return apiClient.post<LintResponse>('/api/approval-route-versions/lint', idOrRequest)
    }
  }

  static async publish(id: string): Promise<{ status: string }> {
    return apiClient.post<{ status: string }>(`/api/approval-route-versions/${id}/publish`)
  }

  static async duplicate(id: string): Promise<ApprovalRouteVersion> {
    return apiClient.post<ApprovalRouteVersion>(`/api/approval-route-versions/${id}/duplicate`)
  }
}
